export const GET_CONTRIBUTUIONS = "GET_CONTRIBUTUIONS";
export const GET_DEPOSITS = "GET_DEPOSITS";
export const GET_VOLUNTARY = "GET_VOLUNTARY";
export const GET_CONTRACTUAL = "GET_CONTRACTUAL";
export const GET_WITHDRAWALS = "GET_WITHDRAWALS";
export const GET_BANKS = "GET_BANKS";
export const VERIFY_BANK = "VERIFY_BANK";
export const VERIFYING_BANK = "VERIFYING_BANK";
export const WITHDRAWING = "WITHDRAWING";
